module.exports = __webpack_public_path__ + "img/45.02a167b2.jpg";